import { render, staticRenderFns } from "./prePolicy.vue?vue&type=template&id=1ce4e7a8&scoped=true&"
import script from "./prePolicy.vue?vue&type=script&lang=js&"
export * from "./prePolicy.vue?vue&type=script&lang=js&"
import style0 from "./prePolicy.vue?vue&type=style&index=0&id=1ce4e7a8&prod&lang=scss&scoped=true&"
import style1 from "./prePolicy.vue?vue&type=style&index=1&id=1ce4e7a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce4e7a8",
  null
  
)

export default component.exports